module.exports = __webpack_public_path__ + "static/media/list-icon.5d0248c5.svg";